// ----------------------------------------------------------------------
const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
  MEDICORE: '/medicore',
  PATIENT: '/patient',
  PATIENT_PORTAL: '/patient-portal',
  JOBS_PORTAL: '/humanResources/apply',
  PUBLICO: '/publico',
};

// ----------------------------------------------------------------------

export const paths = {
  // AUTH
  auth: {
    login: `${ROOTS.AUTH}/login`,
    resetPassword: `${ROOTS.AUTH}/reset-password`,
  },
  // DASHBOARD
  medicore: {
    root: ROOTS.MEDICORE,
    admissions: `${ROOTS.MEDICORE}/admissions`,
    admissionNew: `${ROOTS.MEDICORE}/admissions/new`,
    admissionDetails: (id) => `${ROOTS.MEDICORE}/admissions/${id}`,
    // DOCTORS
    consultingRooms: `${ROOTS.MEDICORE}/consultingRooms`,
    consultingRoomsRent: `${ROOTS.MEDICORE}/consultingRoomsRent`,
    appointmentCalendar: `${ROOTS.MEDICORE}/appointmentCalendar`,
    consultingPatient: `${ROOTS.MEDICORE}/consultingPatient`,
    // EJEMPLO
    ejemplo: `${ROOTS.MEDICORE}/ejemplo`,
    // EMERGENCY
    emergency: {
      root: `${ROOTS.MEDICORE}/emergency`,
      editor: `${ROOTS.MEDICORE}/emergency/editor`,
    },
    // HOSPITALIZED
    hospitalized: `${ROOTS.MEDICORE}/hospitalized`,
    // INTENSIVE CARE UNIT
    intensiveCareUnit: `${ROOTS.MEDICORE}/intensiveCareUnit`,
    // LABORATORIES
    laboratories: `${ROOTS.MEDICORE}/laboratories`,
    // DEATHS
    deaths: `${ROOTS.MEDICORE}/deaths`,
    // ADMISSION REQUESTS
    admissionRequests: `${ROOTS.MEDICORE}/admissionRequests`,
    // ROOMS
    rooms: {
      root: `${ROOTS.MEDICORE}/rooms`,
      new: `${ROOTS.MEDICORE}/rooms/new`,
      list: `${ROOTS.MEDICORE}/rooms/list`,
      details: (id) => `${ROOTS.MEDICORE}/rooms/${id}`,
      newEdit: (roomId) =>
        `${ROOTS.MEDICORE}/rooms/new?roomId=${encodeURIComponent(String(roomId))}`,
    },
    // MEDICAL SERVICE CATALOG
    medicalServiceCatalog: {
      root: `${ROOTS.MEDICORE}/medicalServiceCatalog`,
    },
    // INVOICE-PATIENT
    patientInvoice: {
      root: `${ROOTS.MEDICORE}/patientInvoice`,
      new: `${ROOTS.MEDICORE}/patientInvoice/new`,
      list: `${ROOTS.MEDICORE}/patientInvoice/list`,
    },
    // INVENTORY
    doctorsAdministration: {
      root: `${ROOTS.MEDICORE}/DoctorPlanta`,
    },
    inventory: {
      statistics: `${ROOTS.MEDICORE}/inventory/statistics`,
      list: `${ROOTS.MEDICORE}/inventory/list`,
      warehouse: `${ROOTS.MEDICORE}/inventory/warehouse`,
      listMedicalOrder: `${ROOTS.MEDICORE}/inventory/listMedicalOrder`,
      listExpendableMaterials: `${ROOTS.MEDICORE}/inventory/listExpendableMaterials`,
      purchaseOrder: {
        root: `${ROOTS.MEDICORE}/inventory/purchaseOrder`,
        newPurchaseOrder: `${ROOTS.MEDICORE}/inventory/purchaseOrder/newPurchaseOrder`,
        listPurchaseOrder: `${ROOTS.MEDICORE}/inventory/purchaseOrder/listPurchaseOrder`,
      },
      requisition: {
        root: `${ROOTS.MEDICORE}/inventory/requisition`,
        listRequisition: `${ROOTS.MEDICORE}/inventory/requisition/listRequisition`,
      },
      listProduct: `${ROOTS.MEDICORE}/inventory/listProduct`,
      listProvider: `${ROOTS.MEDICORE}/inventory/listProvider`,
      listCategory: `${ROOTS.MEDICORE}/inventory/listCategory`,
      dispatch: {
        root: `${ROOTS.MEDICORE}/inventory/dispatch`,
        statistics: `${ROOTS.MEDICORE}/inventory/dispatch/statistics`,
        dispatchProduct: `${ROOTS.MEDICORE}/inventory/dispatch/dispatchProduct`,
        dispatchWarehouse: `${ROOTS.MEDICORE}/inventory/dispatch/dispatchWarehouse`,
      },
    },
    // EMPLOYEE REQUEST
    employeeRequest: {
      root: `${ROOTS.MEDICORE}/employeeRequest`,
      request: `${ROOTS.MEDICORE}/employeeRequest/request`,
    },
    // FINANCE
    finance: {
      root: `${ROOTS.MEDICORE}/finance`,
      pos: `${ROOTS.MEDICORE}/finance/pos`,
      accounts: {
        root: `${ROOTS.MEDICORE}/finance/accounts`,
        list: `${ROOTS.MEDICORE}/finance/accounts/list`,
        new: `${ROOTS.MEDICORE}/finance/accounts/new`,
      },
      expenses_purchases: {
        root: `${ROOTS.MEDICORE}/finance/Expenses-purchases`,
        expenses: `${ROOTS.MEDICORE}/finance/Expenses-purchases/listInvoice`,
        purchases: `${ROOTS.MEDICORE}/finance/Expenses-purchases/purchases`,
        expensesForm: `${ROOTS.MEDICORE}/finance/Expenses-purchases/registerInvoice`,
        soldServicesList: `${ROOTS.MEDICORE}/finance/Expenses-purchases/soldInvoiceReport`,
      },
      journal: {
        root: `${ROOTS.MEDICORE}/finance/journal`,
        list: `${ROOTS.MEDICORE}/finance/journal/list`,
        new: `${ROOTS.MEDICORE}/finance/journal/new`,
      },
      checks: {
        root: `${ROOTS.MEDICORE}/finance/checks`,
        list: `${ROOTS.MEDICORE}/finance/checks/list`,
        new: `${ROOTS.MEDICORE}/finance/checks/new`,
      },
      entry: {
        root: `${ROOTS.MEDICORE}/finance/entry`,
        new: `${ROOTS.MEDICORE}/finance/entry/new`,
        list: `${ROOTS.MEDICORE}/finance/entry/list`,
      },
      fixedAssets: {
        root: `${ROOTS.MEDICORE}/finance/fixed-assets`,
      },
      loans: {
        root: `${ROOTS.MEDICORE}/finance/loans`,
      },
      invoices: {
        root: `${ROOTS.MEDICORE}/finance/invoices`,
        list: `${ROOTS.MEDICORE}/finance/invoices/list`,
        new: `${ROOTS.MEDICORE}/finance/invoices/new`,
        edit: (id) => `${ROOTS.MEDICORE}/finance/invoices/edit/${id}`,
      },
      pettyCash: {
        root: `${ROOTS.MEDICORE}/finance/petty-cash`,
      },
      payroll: {
        root: `${ROOTS.MEDICORE}/finance/payroll`,
      },
      ecf: {
        root: `${ROOTS.MEDICORE}/finance/ecf`,
        list: `${ROOTS.MEDICORE}/finance/ecf/list`,
        new: `${ROOTS.MEDICORE}/finance/ecf/new`,
        detail: (id) => `${ROOTS.MEDICORE}/finance/ecf/${id}`,
        settings: `${ROOTS.MEDICORE}/finance/ecf/settings`,
        sequences: `${ROOTS.MEDICORE}/finance/ecf/sequences`,
        listReceived: `${ROOTS.MEDICORE}/finance/ecf/received-ecf`,
        listApproves: `${ROOTS.MEDICORE}/finance/ecf/received-aprobaciones`,
        // Emisión de la aprobación comercial que la clínica manda al EMISOR cuando es
        // receptora. No confundir con `listApproves`, que son las que la clínica RECIBE.
        aprobacionComercial: `${ROOTS.MEDICORE}/finance/ecf/aprobacion-comercial`,
        detailReceived: (id) => `${ROOTS.MEDICORE}/finance/ecf/received-ecf/${id}`,
        detailApproves: (id) => `${ROOTS.MEDICORE}/finance/ecf/received-aprobaciones/${id}`,
      },
      report: {
        root: `${ROOTS.MEDICORE}/finance/report`,
        trialBalance: `${ROOTS.MEDICORE}/finance/report/trialBalance`,
        incomeStatement: `${ROOTS.MEDICORE}/finance/report/incomeStatement`,
      },
    },
    // NURSE
    nurse: {
      root: `${ROOTS.MEDICORE}/nurse`,
      shifts: `${ROOTS.MEDICORE}/nurse/shifts`,
      requestproducts: `${ROOTS.MEDICORE}/nurse/requestproducts`,
    },
    // INSURANCE
    insurance: {
      root: `${ROOTS.MEDICORE}/insurance`,
      providers: {
        root: `${ROOTS.MEDICORE}/insurance/providers`,
        list: `${ROOTS.MEDICORE}/insurance/providers/list`,
        new: `${ROOTS.MEDICORE}/insurance/providers/new`,
      },
      authorizations: {
        root: `${ROOTS.MEDICORE}/insurance/authorizations`,
        list: `${ROOTS.MEDICORE}/insurance/authorizations/list`,
        new: `${ROOTS.MEDICORE}/insurance/authorizations/new`,
      },
      audit: {
        root: `${ROOTS.MEDICORE}/insurance/audit`,
        list: `${ROOTS.MEDICORE}/insurance/audit/list`,
      },
    },
    // HUMAN RESOURCES
    humanResources: {
      root: `${ROOTS.MEDICORE}/humanResources`,
      employees: {
        root: `${ROOTS.MEDICORE}/humanResources/employees`,
        list: `${ROOTS.MEDICORE}/humanResources/employees/list`,
        new: `${ROOTS.MEDICORE}/humanResources/employees/new`,
      },
      doctors: {
        root: `${ROOTS.MEDICORE}/humanResources/doctors`,
        list: `${ROOTS.MEDICORE}/humanResources/doctors/list`,
        new: `${ROOTS.MEDICORE}/humanResources/doctors/new`,
        shift: `${ROOTS.MEDICORE}/humanResources/doctors/shift`,
      },
      departments: {
        root: `${ROOTS.MEDICORE}/humanResources/departments`,
      },
      jobPositions: {
        root: `${ROOTS.MEDICORE}/jobPositions`,
        new: `${ROOTS.MEDICORE}/jobPositions/new`,
        edit: (id) => `${ROOTS.MEDICORE}/jobPositions/edit/${id}`,
        details: (id) => `${ROOTS.MEDICORE}/jobPositions/details/${id}`,
        apply: `${ROOTS.JOBS_PORTAL}/jobs`,
      },
    },
    // CONFIGURATION
    configuration: {
      root: `${ROOTS.MEDICORE}/configuration`,
      equipmentCategory: {
        root: `${ROOTS.MEDICORE}/configuration/equipment-category`,
        list: `${ROOTS.MEDICORE}/configuration/equipment-category/list`,
        new: `${ROOTS.MEDICORE}/configuration/equipment-category/new`,
        edit: (id) => `${ROOTS.MEDICORE}/configuration/equipment-category/edit/${id}`,
      },
      doctorFeesCatalog: {
        root: `${ROOTS.MEDICORE}/configuration/doctor-fees-catalog`,
        list: `${ROOTS.MEDICORE}/configuration/doctor-fees-catalog/list`,
      },
      doctorServicesCatalog: {
        root: `${ROOTS.MEDICORE}/configuration/doctor-services-catalog`,
        list: `${ROOTS.MEDICORE}/configuration/doctor-services-catalog/list`,
      },
      doctorSpeciality: {
        root: `${ROOTS.MEDICORE}/configuration/doctor-speciality`,
        list: `${ROOTS.MEDICORE}/configuration/doctor-speciality/list`,
      },
      dynamicAccounting: {
        root: `${ROOTS.MEDICORE}/configuration/dynamic-accounting`,
        list: `${ROOTS.MEDICORE}/configuration/dynamic-accounting/list`,
        entityMappings: {
          root: `${ROOTS.MEDICORE}/configuration/dynamic-accounting/entity-mappings`,
          list: `${ROOTS.MEDICORE}/configuration/dynamic-accounting/entity-mappings/list`,
          new: `${ROOTS.MEDICORE}/configuration/dynamic-accounting/entity-mappings/new`,
          edit: (id) =>
            `${ROOTS.MEDICORE}/configuration/dynamic-accounting/entity-mappings/edit/${id}`,
        },
        journalTemplates: {
          root: `${ROOTS.MEDICORE}/configuration/dynamic-accounting/journal-templates`,
          list: `${ROOTS.MEDICORE}/configuration/dynamic-accounting/journal-templates/list`,
          new: `${ROOTS.MEDICORE}/configuration/dynamic-accounting/journal-templates/new`,
          edit: (id) =>
            `${ROOTS.MEDICORE}/configuration/dynamic-accounting/journal-templates/edit/${id}`,
        },
      },
      taxes: {
        root: `${ROOTS.MEDICORE}/configuration/taxes`,
      },
      deviceMaintenance: {
        root: `${ROOTS.MEDICORE}/configuration/device-maintenance`,
      },
      centroMembrete: {
        root: `${ROOTS.MEDICORE}/configuration/centro-membrete`,
      },
      // Catálogo CLÍNICO (vademécum de la receta), no el de almacén.
      medicamentoCatalogo: {
        root: `${ROOTS.MEDICORE}/configuration/medicamento-catalogo`,
      },
      SystemParameters: {
        root: `${ROOTS.MEDICORE}/configuration/system-parameters`,
      },
    },
    // USER MANAGEMENT
    userManagement: {
      root: `${ROOTS.MEDICORE}/userManagement`,
      list: `${ROOTS.MEDICORE}/userManagement/list`,
      rolesPermissions: `${ROOTS.MEDICORE}/userManagement/rolesPermissions`,
    },
  },

  // PATIENTS
  patient: {
    root: `${ROOTS.PATIENT}`,
    login: `${ROOTS.PATIENT}${ROOTS.PATIENT_PORTAL}/login`,
    appointments: `${ROOTS.PATIENT}${ROOTS.PATIENT_PORTAL}/appointments`,
    results: `${ROOTS.PATIENT}${ROOTS.PATIENT_PORTAL}/results`,
    digitalReport: (id) => `${ROOTS.PATIENT}${ROOTS.PATIENT_PORTAL}/digital-report/${id}`,
    list: `${ROOTS.PATIENT}/list`,
    new: `${ROOTS.PATIENT}/new`,
    edit: (id) => `${ROOTS.PATIENT}/edit/${id}`,
    rawing: `${ROOTS.PATIENT}/rawing`,
  },

  // PÚBLICO — sin autenticación ni permisos. No va en ROUTE_PERMISSIONS ni en la
  // navegación: se llega por el QR impreso en el papel, nunca desde el menú.
  publico: {
    // Debe coincidir con VerificacionReceta:UrlPublicaBase del backend, que es lo que
    // queda codificado en los QR ya impresos.
    recetaVerificacion: `${ROOTS.PUBLICO}/receta`,
    recetaVerificacionToken: (token) =>
      `${ROOTS.PUBLICO}/receta/${encodeURIComponent(String(token))}`,
  },
};
